module.exports = __webpack_public_path__ + "img/ic_band_right_normal.8a8d802b.png";